
import { createSlice } from '@reduxjs/toolkit'

const navigationSlice = createSlice({
    name: 'navigation',
    initialState: {
        redirectTo: null as string | null,
    },
    reducers: {
        redirect: (state, action) => {
            state.redirectTo = action.payload
        },
        clearRedirect: (state) => {
            state.redirectTo = null
        },
    },
})

export const { redirect, clearRedirect } = navigationSlice.actions
export default navigationSlice.reducer
